import React, { Component } from 'react';
import { decodePaletteData } from '../helpers/shareHelpers';
import MiniPalette from '../MiniPalette';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import SaveIcon from '@material-ui/icons/Save';
import HomeIcon from '@material-ui/icons/Home';
import { Link } from 'react-router-dom';
import GlobalNav from './GlobalNav';

const styles = theme => ({
    root: {
        minHeight: "calc(100vh - 57px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
        padding: "2rem",
    },
    container: {
        width: "100%",
        maxWidth: "500px",
        padding: "2rem",
        textAlign: "center",
        backgroundColor: theme.palette.background.paper,
        borderRadius: "12px",
        boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
    },
    palettePreview: {
        margin: "2rem 0",
        textAlign: "left",
    },
    title: {
        marginBottom: "1rem",
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    subtitle: {
        marginBottom: "2rem",
        color: theme.palette.text.secondary,
    },
    actions: {
        display: "flex",
        justifyContent: "center",
        gap: "1rem",
        marginTop: "2rem",
        flexWrap: "wrap",
    },
    button: {
        padding: "0.75rem 1.5rem",
        fontWeight: 600,
    },
    successMessage: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "#4caf50",
        marginBottom: "2rem",
    },
    error: {
        color: "#f44336",
    }
});

class ShareHandler extends Component {
    constructor(props) {
        super(props);
        const { encodedData } = this.props.match.params;
        const decodedPalette = decodePaletteData(encodedData);

        this.state = {
            palette: decodedPalette,
            saved: false,
            error: !decodedPalette
        };
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave() {
        const { palette } = this.state;
        const { palettes, savePalette, history } = this.props;

        // Check if palette with same name already exists
        let uniqueName = palette.paletteName;
        let count = 1;

        const nameExists = (name) => palettes.some(p => p.paletteName.toLowerCase() === name.toLowerCase());

        while (nameExists(uniqueName)) {
            uniqueName = `${palette.paletteName} (${count})`;
            count++;
        }

        const paletteToSave = {
            ...palette,
            paletteName: uniqueName,
            id: uniqueName.toLowerCase().replace(/ /g, "-")
        };

        savePalette(paletteToSave);
        this.setState({ saved: true });

        // Optional: redirect after short delay
        setTimeout(() => {
            history.push(`/palette/${paletteToSave.id}`);
        }, 1500);
    }

    render() {
        const { classes } = this.props;
        const { palette, saved, error } = this.state;

        let content;
        if (error) {
            content = (
                <Paper className={classes.container}>
                    <ErrorIcon className={classes.error} style={{ fontSize: "4rem", marginBottom: "1rem" }} />
                    <Typography variant="h4" className={classes.title}>Invalid Link</Typography>
                    <Typography className={classes.subtitle}>
                        This shared palette link seems to be broken or malformed.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/"
                        startIcon={<HomeIcon />}
                        className={classes.button}
                    >
                        Go Home
                    </Button>
                </Paper>
            );
        } else if (saved) {
            content = (
                <Paper className={classes.container}>
                    <div className={classes.successMessage}>
                        <CheckCircleIcon style={{ fontSize: "5rem", marginBottom: "1rem" }} />
                        <Typography variant="h4" className={classes.title}>Saved!</Typography>
                    </div>
                    <Typography className={classes.subtitle}>
                        "{palette.paletteName}" has been added to your collection.
                        Redirecting you now...
                    </Typography>
                </Paper>
            );
        } else {
            content = (
                <Paper className={classes.container}>
                    <Typography variant="h4" className={classes.title}>Shared Palette</Typography>
                    <Typography className={classes.subtitle}>
                        Someone shared a color palette with you! Would you like to save it?
                    </Typography>

                    <div className={classes.palettePreview}>
                        <MiniPalette
                            {...palette}
                            editable={false}
                            deletable={false}
                            handleClick={() => {}}
                            handleDelete={() => {}}
                        />
                    </div>

                    <div className={classes.actions}>
                        <Button
                            variant="outlined"
                            color="default"
                            component={Link}
                            to="/"
                            className={classes.button}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleSave}
                            startIcon={<SaveIcon />}
                            className={classes.button}
                        >
                            Save Palette
                        </Button>
                    </div>
                </Paper>
            );
        }

        return (
            <>
                <GlobalNav />
                <div className={classes.root}>{content}</div>
            </>
        );
    }
}

export default withStyles(styles)(ShareHandler);
